var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticStyle:{"position":"relative","margin":"auto"},style:(_vm.showBubbleContents? 'height: 700px; width: 700px;': 'height: 400px; width: 400px;')},[_c('div',{style:({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: `${_vm.diameter}px`,
        height: `${_vm.diameter}px`,
        borderRadius: '50%',
        background: 'white',
        boxShadow: 'inset 0px 2px 10px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '12px',
        zIndex: 100,
    })},[_vm._v(" Key Subjects ")]),_vm._l((_vm.positionedBubbles),function(bubble,index){return _c('div',{key:index},[_c('div',{style:({
            position: 'absolute',
            width: `${_vm.diameter}px`,
            height: `${_vm.diameter}px`,
            borderRadius: '50%',
            background: '#D7F5E9',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            boxShadow: 'inset 0px 2px 10px rgba(0,0,0,0.1)',
            fontSize: '12px',
            wordWrap: 'break-word',
            zIndex: 100,
            top: `calc(50% + ${bubble.y}px)`,
            left: `calc(50% + ${bubble.x}px)`,
            transform: 'translate(-50%, -50%)',
            backgroundColor: `${bubble.backgroundColor}`,
        })},[_vm._v(" "+_vm._s(_vm.formatLabel(bubble?.name))+" ")]),(_vm.showBubbleContents)?_c('div',{staticStyle:{"position":"absolute","width":"150px","border-radius":"16px","background":"#D7F5E9","display":"flex","flex-direction":"column","justify-content":"center","padding":"8px","box-shadow":"0px 2px 8px 0px #0000001A","font-size":"12px","word-wrap":"break-word","z-index":"100"},style:({
            top: `calc(50% + ${bubble.contentsY}px)`,
            left: `calc(50% + ${bubble.contentsX}px)`,
            transform: 'translate(-50%, -50%)',
            backgroundColor: `${bubble.backgroundColor}`,
            })},[_c('ul',_vm._l((bubble?.topics),function(topic,index){return _c('li',{key:index,staticStyle:{"color":"#666666"}},[_vm._v(_vm._s(topic))])}),0)]):_vm._e(),_c('svg',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","pointer-events":"none","z-index":"1"}},_vm._l((_vm.positionedBubbles),function(bubble,index){return _c('line',{key:'line-'+index,attrs:{"x1":_vm.containerCenter.x + bubble.x,"y1":_vm.containerCenter.y + bubble.y,"x2":_vm.showBubbleContents? _vm.containerCenter.x + bubble.contentsX : _vm.containerCenter.x,"y2":_vm.showBubbleContents? _vm.containerCenter.y + bubble.contentsY : _vm.containerCenter.y,"stroke":"#666666","stroke-width":"1"}})}),0)])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }